import DataTableWithFilters from './DataTableWithFilters-compose';

export default DataTableWithFilters;
